module.exports = __webpack_public_path__ + "065378d067e39d618aefd16bc9ed637b.png";